// removed by extract-text-webpack-plugin
module.exports = {"totalSavings":"styles__totalSavings__LzrzN","buttons":"styles__buttons__GfQN8","tweetButton":"styles__tweetButton__HqwcJ","downloadButton":"styles__downloadButton__1PjK0","twitterIcon":"styles__twitterIcon__1q4Jv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PdfCompressor/styles.scss
// module id = 852
// module chunks = 0